import React from 'react';

function NotFound() {
  return (
    <div>
      <h2>404 - الصفحة غير موجودة</h2>
      <p>عذراً، الصفحة التي تبحث عنها غير متوفرة.</p>
    </div>
  );
}

export default NotFound;
